import React from 'react';
import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import ProductShowcase from '../components/ProductShowcase';
import HowItWorks from '../components/HowItWorks';
import CompanyTrust from '../components/CompanyTrust';
import HomeVideos from '../components/HomeVideos';
import ContactCTA from '../components/ContactCTA';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <StatsBar />
      <ProductShowcase />
      <HowItWorks />
      <CompanyTrust />
      <HomeVideos />
      <ContactCTA />
    </div>
  );
};

export default Home;

